import _ from 'lodash';

export const unmarshalGraphqlEdges = (obj, removeEdgesAttr = false) => {
  const clone = _.cloneDeep(obj);

  for (const key of Object.keys(clone)) {
    if (key === 'edges') {
      const plain = [];
      for (const item of clone[key]) {
        plain.push({ ...item.node });
      }
      clone[key] = plain;
    } else if (_.has(clone, `${key}.edges`)) {
      const plain = [];
      for (const item of _.get(clone, `${key}.edges`)) {
        plain.push({ ...item.node });
      }
      clone[key] = plain;
    }
  }
  if (removeEdgesAttr) {
    if (typeof clone.edges !== 'undefined') {
      return clone.edges;
    }
  }
  return clone;
};
